<template>
    <rkm-form ref="form" class="login-form">
        <h1>Esqueceu sua senha?</h1>
        <h5>Informe seus dados para gerar uma nova</h5>

        <rkm-row>
            <rkm-col>
                <rkm-form-input
                    name="CPF"
                    v-model="model.cpf"
                    v-mask="mask.cpf"
                    :validations="validations.cpf"
                    placeholder="CPF"
                >
                    <rkm-input-group-prepend slot="prepend">
                        <rkm-input-group-text><rkm-icon :icon="['far', 'user-circle']" /></rkm-input-group-text>
                    </rkm-input-group-prepend>
                </rkm-form-input>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-input
                    name="E-mail"
                    placeholder="E-mail"
                    v-model="model.email"
                    :validations="validations.email"
                >
                    <rkm-input-group-prepend slot="prepend">
                        <rkm-input-group-text><rkm-icon :icon="['far', 'envelope']" /></rkm-input-group-text>
                    </rkm-input-group-prepend>
                </rkm-form-input>
            </rkm-col>
        </rkm-row>

        <div class="login-form-actions">
            <rkm-button
                color="primary"
                type="submit"
                @click="$refs.form.validate(recuperarAcesso)"
            >
                Recuperar acesso
            </rkm-button>

            <rkm-button
                @click.stop="$router.push({ name: 'login', params: { customer: $route.params.customer } })"
            >
                Voltar ao login
            </rkm-button>
        </div>
    </rkm-form>
</template>

<script>
import { mapActions } from "vuex"
import { repository, error, mask, unmask } from '@/mixins'

export default {
    created() {
        this.repositories.cliente = this.getConectaSusRepository('intranet.cliente')
        this.repositories.autenticacao = this.getConectaSusRepository('administracao.autenticacao')
    },
    mixins: [ repository, error, mask, unmask ],
    data: () => ({
        model: {
            cpf: null,
            email: null,
        },
        repositories: {},
    }),
    computed: {
         validations() {
            return {
                cpf: {
                    required: true,
                    min_max_without_mask: 11,
                    cpf: true
                },
                email: {
                    required: true,
                    min: 5,
                    max: 180,
                    email: true,
                },
            }
        },
    },
    methods: {
        ...mapActions([
            'setLoading',
            'unsetLoading',
            'setAutenticacao',
            'setCustomer',
            'clear'
        ]),
        load(customer) {
            this.setLoading()

            this.repositories.cliente.index({link: customer})
                .then(({ data }) => {
                    this.setCustomer(data)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        recuperarAcesso() {

            this.setLoading()

            this.repositories.autenticacao.recuperarSenha({
                cpf: this.unMaskCpf(this.model.cpf),
                email: this.model.email
            })
                .then(({ data }) => {

                    this.showSaveNotification(data.message)

                    this.$router.push({ name: 'login', params: { customer: this.$route.params.customer } })
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mounted() {
        const env = process.env.VUE_APP_ENV
        let customer = null

        if (env === 'production') {
            customer = window.location.hostname.split('.')[0]
        } else {
            customer = this.$route.params.customer
        }

        this.clear().then(() => {
            if(customer) {
                this.load(customer)
            }
        });
    },
}
</script>

<style>
button:focus {
    opacity: 0.8;
}

#recuperar-senha-inner {
    max-width: 450px;
}

#recuperar-senha-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

h5 {
    font-size: 17px;
}

h6 {
    font-size: 12px;
    opacity: 0.5;
}

#metodo-recuperacao label:before, #metodo-recuperacao label:after {
    display: none;
}

#metodo-recuperacao .custom-radio {
    padding: 0;
    margin: 0;
    height: 100%;
}

#metodo-recuperacao label {
    display: block;
    border: 1px solid rgba(0,0,0,0.1);
    padding: 2rem;
    border-radius: 4px;
    cursor: pointer;
    background: #FFF;
    transition: border-color 0.3s, box-shadow 0.3s;
}

.list-group-item {
    cursor: pointer;
}

#metodo-recuperacao input:checked + label {
    border-color: var(--primary);
    box-shadow: 0px 0px 0 3px rgb(63 106 216 / 30%), 0px 0px 30px -10px var(--primary);
}

.list-group-item[selected] {
    background: rgb(63 106 216 / 5%);
    border-color: var(--primary);
    z-index: 2;
}

#metodo-recuperacao label strong {
    display: block;
    font-size: 17px;
}
</style>